import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5887e8cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "case-laboratory-data"
}
const _hoisted_2 = { class: "grid-container" }
const _hoisted_3 = { class: "form-item" }
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = { class: "next-testing" }
const _hoisted_7 = { style: {"padding":"0 40px"} }
const _hoisted_8 = {
  key: 0,
  class: "table table-bordered"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "overflow-ellipsis",
      width: "20%"
    }, "Date"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "overflow-ellipsis",
      width: "20%"
    }, "GGT"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "overflow-ellipsis",
      width: "20%"
    }, "GOT"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "overflow-ellipsis",
      width: "20%"
    }, "GPT"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "overflow-ellipsis",
      width: "20%"
    }, "Actions")
  ])
], -1))
const _hoisted_10 = { class: "wrap-words" }
const _hoisted_11 = { class: "lab-result-actions" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "empty-block" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "empty-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsDatepicker = _resolveComponent("AsDatepicker")!
  const _component_AsReadWriteBlock = _resolveComponent("AsReadWriteBlock")!
  const _component_AsMultiSelect = _resolveComponent("AsMultiSelect")!
  const _component_AsDropdown = _resolveComponent("AsDropdown")!
  const _component_AsEditBlock = _resolveComponent("AsEditBlock")!
  const _component_AsTextWithLabel = _resolveComponent("AsTextWithLabel")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_AsBlock = _resolveComponent("AsBlock")!
  const _component_fa = _resolveComponent("fa")!
  const _component_AsButton = _resolveComponent("AsButton")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_CaseLaboratoryModal = _resolveComponent("CaseLaboratoryModal")!
  const _component_vue_pdf_app = _resolveComponent("vue-pdf-app")!
  const _component_AsModal = _resolveComponent("AsModal")!

  return (_ctx.canRead(_ctx.caseScope.Laboratory))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AsEditBlock, {
          header: _ctx.$t('case.laboratory.settings.title'),
          editParams: _ctx.settingsConfig,
          isReadOnly: !_ctx.canWrite(_ctx.caseScope.Laboratory) || _ctx.isCaseDeleted,
          onEditModeEnabled: _ctx.processSettingsEditEnable,
          onEditModeSubmit: _ctx.processSettingsSubmit,
          onEditModeCanceled: _ctx.processSettingsCancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_AsReadWriteBlock, {
                  label: _ctx.$t('case.laboratory.settings.firstTest'),
                  value: _ctx.formatDate(_ctx.labSettings['firstTestDate']),
                  isReadOnly: _ctx.isSettingsFormReadOnly
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AsDatepicker, {
                      placeholder: _ctx.$t('case.laboratory.settings.firstTestPlaceholder'),
                      enableTimePicker: false,
                      value: _ctx.labSettings.firstTestDate,
                      onUpdate: _cache[0] || (_cache[0] = (date) => (_ctx.labSettings.firstTestDate = date))
                    }, null, 8, ["placeholder", "value"])
                  ]),
                  _: 1
                }, 8, ["label", "value", "isReadOnly"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_AsReadWriteBlock, {
                  label: _ctx.$t('case.laboratory.settings.testTypes'),
                  value: _ctx.getTestTypesNames(_ctx.labSettings.testTypes),
                  isReadOnly: _ctx.isSettingsFormReadOnly
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AsMultiSelect, {
                      placeholder: _ctx.$t('case.laboratory.settings.testTypesPlaceholder'),
                      clearIcon: true,
                      value: _ctx.labSettings.testTypes,
                      options: _ctx.getLookUpOptions(_ctx.lvTypes.LaboratoryResultTestType),
                      optionValue: 'id',
                      optionLabel: 'value',
                      onUpdate: _cache[1] || (_cache[1] = (value) => (_ctx.labSettings.testTypes = value))
                    }, null, 8, ["placeholder", "value", "options"])
                  ]),
                  _: 1
                }, 8, ["label", "value", "isReadOnly"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_AsReadWriteBlock, {
                  label: _ctx.$t('case.laboratory.settings.interval'),
                  value: _ctx.getIntervalReadonlyName(_ctx.labSettings.monthsInterval),
                  isReadOnly: _ctx.isSettingsFormReadOnly
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AsDropdown, {
                      clearIcon: true,
                      value: _ctx.labSettings.monthsInterval,
                      options: _ctx.monthsIntervalOptions,
                      placeholder: _ctx.$t('case.laboratory.settings.intervalPlaceholder'),
                      optionLabel: 'label',
                      optionValue: 'value',
                      onUpdate: _cache[2] || (_cache[2] = (value) => (_ctx.labSettings.monthsInterval = value))
                    }, null, 8, ["value", "options", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label", "value", "isReadOnly"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header", "editParams", "isReadOnly", "onEditModeEnabled", "onEditModeSubmit", "onEditModeCanceled"]),
        (_ctx.labData.nextLabTestInfo && _ctx.labData.nextLabTestInfo.nextLaboratoryTestDate)
          ? (_openBlock(), _createBlock(_component_AsBlock, {
              key: 0,
              header: _ctx.$t('case.laboratory.NextTesting')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_AsTextWithLabel, {
                    label: _ctx.$t('date'),
                    value: _ctx.formatStringDate(_ctx.labData.nextLabTestInfo?.nextLaboratoryTestDate)
                  }, null, 8, ["label", "value"]),
                  (_ctx.labData.nextLabTestInfo?.isNextTestOverdue)
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        severity: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('case.laboratory.NextTestOverdue')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_AsBlock, {
          header: _ctx.$t('case.laboratory.results.title')
        }, {
          header: _withCtx(() => [
            (!_ctx.isCaseDeleted && _ctx.canWrite(_ctx.caseScope.Laboratory))
              ? (_openBlock(), _createBlock(_component_AsButton, {
                  key: 0,
                  label: _ctx.$t('new'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.initTestResultModal()))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_fa, { icon: "icon fa-plus" })
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_ctx.labTests && _ctx.labTests.length)
              ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labTests, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.formatDate(item['testDateTime'])), 1),
                        _createElementVNode("td", {
                          class: "wrap-words",
                          style: _normalizeStyle(_ctx.getTestStyle(item.testResultTypeId))
                        }, _toDisplayString(item.ggt), 5),
                        _createElementVNode("td", {
                          class: "wrap-words",
                          style: _normalizeStyle(_ctx.getTestStyle(item.testResultTypeId))
                        }, _toDisplayString(item.got), 5),
                        _createElementVNode("td", {
                          class: "wrap-words",
                          style: _normalizeStyle(_ctx.getTestStyle(item.testResultTypeId))
                        }, _toDisplayString(item.gpt), 5),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_11, [
                            (!_ctx.isCaseDeleted && _ctx.canWrite(_ctx.caseScope.Laboratory))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_fa, {
                                    icon: "icon fa-pencil cursor-pointer",
                                    class: "cursor-pointer i-navigate-button",
                                    onClick: ($event: any) => (_ctx.editLabResult(item))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.isCaseDeleted && _ctx.canWrite(_ctx.caseScope.Laboratory))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("i", {
                                    class: "pi pi-trash cursor-pointer i-navigate-button",
                                    onClick: ($event: any) => (_ctx.removeLabResult($event, item.id))
                                  }, null, 8, _hoisted_14),
                                  _createVNode(_component_ConfirmPopup)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _createElementVNode("i", {
                                disabled: "",
                                class: _normalizeClass(["pi i-navigate-button", [item.testResultFile && item.testResultFile.id ? 'pi-eye cursor-pointer' : 'pi-eye-slash']]),
                                onClick: ($event: any) => (_ctx.processPreviewResultClick(item))
                              }, null, 10, _hoisted_15)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["header"]),
        (!_ctx.labTests || !_ctx.labTests.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_AsBlock, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('noData')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_CaseLaboratoryModal, {
          openLabTestResultDetails: _ctx.openTestResultModal,
          caseLaboratorySettingsId: _ctx.labSettings.id,
          onCloseModal: _ctx.processCloseModal
        }, null, 8, ["openLabTestResultDetails", "caseLaboratorySettingsId", "onCloseModal"]),
        (_ctx.previewDocument)
          ? (_openBlock(), _createBlock(_component_AsModal, {
              key: 2,
              showCloseButton: true,
              hideFooter: true,
              open: _ctx.previewDocument,
              onClose: _ctx.closePreviewDocument,
              size: 'large'
            }, {
              header: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.previewFile.name), 1)
              ]),
              body: _withCtx(() => [
                _createVNode(_component_vue_pdf_app, {
                  style: {"height":"72vh"},
                  pdf: _ctx.previewFile.arrayBuffer
                }, null, 8, ["pdf"])
              ]),
              _: 1
            }, 8, ["open", "onClose"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
        _createVNode(_component_AsBlock, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('noData')), 1)
          ]),
          _: 1
        })
      ]))
}